import React from 'react';
import { TREE, FLOW } from '../content/narrative';

/* Every node runs the same loop. The robot and its assemblies each sit at
   their own step of the seven-step cycle; only the drive (the walk's
   sub-assembly) opens down to its parts. A node whose revision has closed the
   loop shows all seven steps met — evidence-backed, like the walk's Beat 11. */

const mono = "'JetBrains Mono', ui-monospace, 'SF Mono', Menlo, Consolas, monospace";
const sans = "ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";
const GREEN = 'var(--wb-green)';

const Pips = ({ at, done }) => (
  <span className="flex gap-[3px]" aria-label={done ? 'All seven steps met' : `On ${FLOW.steps[at].name}`}>
    {FLOW.steps.map((st, i) => {
      const met = done || i < at;
      const cur = !done && i === at;
      return (
        <span
          key={st.id}
          title={st.name}
          style={{
            width: 9, height: 9, borderRadius: 2,
            background: met ? GREEN : cur ? 'var(--wb-orange)' : 'transparent',
            border: `1px ${met || cur ? 'solid' : 'dashed'} ${met ? GREEN : cur ? 'var(--wb-orange)' : 'var(--wb-line)'}`,
          }}
        />
      );
    })}
  </span>
);

const ProductTree = () => (
  <div style={{ background: 'var(--wb-paper)', border: '1px solid var(--wb-line)', borderRadius: 14, overflow: 'hidden' }}>
    <div style={{ padding: '14px 16px', borderBottom: '1px solid var(--wb-line)', background: 'var(--wb-soft)' }}>
      <div className="wb-display" style={{ fontSize: 'var(--t-md)', fontWeight: 600, fontFamily: 'inherit' }}>{TREE.headline}</div>
      <p style={{ margin: '4px 0 0', fontFamily: sans, fontSize: 'var(--t-sm)', color: 'var(--wb-muted)', lineHeight: 1.5 }}>{TREE.line}</p>
    </div>
    <ul className="list-none m-0 p-0" role="tree" aria-label="RBT-100 Warehouse robot product tree">
      {TREE.nodes.map((n) => (
        <li
          key={n.id}
          role="treeitem"
          aria-level={n.depth + 1}
          className="flex flex-wrap items-center justify-between gap-x-3 gap-y-1"
          style={{
            padding: '8px 16px', paddingLeft: 16 + n.depth * 18, borderBottom: '1px solid var(--wb-line)',
            background: n.focus ? 'rgba(185,79,30,0.06)' : 'transparent',
          }}
        >
          <span style={{ minWidth: 0, fontFamily: sans, fontSize: 'var(--t-sm)', color: 'var(--wb-ink)' }}>
            {n.depth > 0 && <span aria-hidden style={{ color: 'var(--wb-line)', marginRight: 6 }}>└</span>}
            <span style={{ fontFamily: mono, fontWeight: n.depth <= 1 ? 800 : 600 }}>{n.id}</span>
            {n.name && <span> {n.name}</span>}
            <span style={{ color: 'var(--wb-muted)' }}> · {n.level}</span>
          </span>
          <span className="flex items-center gap-2" style={{ fontFamily: mono, fontSize: 'var(--t-sm)', color: n.done ? GREEN : 'var(--wb-muted)' }}>
            <span>{n.status}</span>
            <Pips at={n.at ?? 0} done={n.done} />
          </span>
        </li>
      ))}
    </ul>
  </div>
);

export default ProductTree;
